import { ActionTree } from 'vuex'
import { EnvelopeService } from '@/services/EnvelopeService'

import types from './types'
const { GENERIC_MUTATION } = types

const setOpenSidebar = ({ commit, state }: any) => {
  const { openSidebar } = state

  commit(GENERIC_MUTATION, {
    property: 'openSidebar',
    value: !openSidebar
  })
}

const setEnvelops = ({ commit }: any, envelopes: any) => {
  commit(GENERIC_MUTATION, {
    property: 'envelopes',
    value: envelopes
  })
}

const fetchStatusEnvelopes = ({ commit }: any, statusEnvelopes: any) => {
  commit(GENERIC_MUTATION, {
    property: 'statusEnvelopes',
    value: statusEnvelopes
  })
}

const filteredStatusEnvelopes = ({ commit }: any, filteredStatus: any) => {
  commit(GENERIC_MUTATION, {
    property: 'filteredStatus',
    value: filteredStatus
  })
}

const setEnvelopsINeedToSign = ({ commit }: any, envelopesINeedToSign: any) => {
  commit(GENERIC_MUTATION, {
    property: 'envelopesINeedToSign',
    value: envelopesINeedToSign
  })
}

const setEnvelopsOthersPendingSign = ({ commit }: any, envelopesOthersPendingSign: any) => {
  commit(GENERIC_MUTATION, {
    property: 'envelopesOthersPendingSign',
    value: envelopesOthersPendingSign
  })
}

const fetchEnvelops = async (
  { dispatch }: any,
  { folderId, page, size }: any
) => {
  dispatch('setShowSpinContent', true)
  try {
    const envelopes = (await EnvelopeService.getInstance().listEnvelopes(
      folderId,
      page,
      size
    )) as any
    dispatch('setShowSpinContent', false)
    dispatch('setEnvelops', envelopes)
  } catch (err) {
    dispatch('setShowSpinContent', false)
  }
}

const fetchEnvelopesByVault = async (
  { dispatch }: any,
  { folderId, status, page, size, filtered }: any
) => {
  dispatch('setShowSpinContent', true)
  try {
    const envelopes = (await EnvelopeService.getInstance().listEnvelopesByVault(
      folderId,
      page,
      size,
      status
    )) as any

    dispatch('setShowSpinContent', false)
    dispatch('setEnvelops', envelopes)
    dispatch('fetchStatusEnvelopes', envelopes.statusEnvelope)
    dispatch('filteredStatusEnvelopes', filtered)
  } catch (err) {
    dispatch('setShowSpinContent', false)
  }
}

const fetchEnvelopesByUser = async (
  { dispatch }: any,
  { page, size, status, filtered }: any
) => {
  dispatch('setShowSpinContent', true)
  try {
    const envelopes = (await EnvelopeService.getInstance().listEnvelopesByUser(
      page,
      size,
      status,
      filtered
    )) as any

    dispatch('setEnvelops', envelopes)
    dispatch('fetchStatusEnvelopes', envelopes.statusEnvelope)
    dispatch('setShowSpinContent', false)
    dispatch('filteredStatusEnvelopes', filtered)
  } catch (err) {
    dispatch('setShowSpinContent', false)
  }
}

const fetchSearchEnvelope = async (
  { dispatch }: any,
  { term, status, folderId, filtered }: any
) => {
  dispatch('setShowSpinContent', true)
  try {
    const envelopes = (await EnvelopeService.getInstance().searchEnvelope(
      term, status, folderId, filtered
    )) as any
    dispatch('setShowSpinContent', false)
    dispatch('setEnvelops', envelopes)
    dispatch('filteredStatusEnvelopes', filtered)
    dispatch('fetchStatusEnvelopes', envelopes.statusEnvelope)
  } catch (err) {
    dispatch('setShowSpinContent', false)
  }
}

const fetchEnvelopesINeedToSign = async (
  { dispatch }: any,
  { page, size, status, limit, filtered }: any
) => {
  dispatch('setShowSpinContent', true)
  try {
    const envelopesINeedToSign = (await EnvelopeService.getInstance().listEnvelopesByUser(
      page,
      size,
      status,
      filtered,
      limit
    )) as any
    dispatch('setEnvelopsINeedToSign', envelopesINeedToSign)
    dispatch('setShowSpinContent', false)
  } catch (err) {
    dispatch('setShowSpinContent', false)
  }
}

const fetchEnvelopesOthersPendingSign = async (
  { dispatch }: any,
  { page, size, status, limit, filtered }: any
) => {
  dispatch('setShowSpinContent', true)
  try {
    const envelopesOthersPendingSign = (await EnvelopeService.getInstance().listEnvelopesByUser(
      page,
      size,
      status,
      filtered,
      limit
    )) as any
    dispatch('setEnvelopsOthersPendingSign', envelopesOthersPendingSign)
    dispatch('setShowSpinContent', false)
  } catch (err) {
    dispatch('setShowSpinContent', false)
  }
}

const fetchHistoricEnvelops = async (
  { commit, dispatch }: any,
  { folderId, envelopeId }: any
) => {
  dispatch('setOpenHistoric', true)
  const historic = await EnvelopeService.getInstance().listInfoEnvelope(
    folderId,
    envelopeId
  )

  commit(GENERIC_MUTATION, {
    property: 'historicEnvelopes',
    value: historic
  })
}

const setFolderId = ({ commit }: any, folderId: any) => {
  localStorage.setItem('folderId', folderId)
  commit(GENERIC_MUTATION, {
    property: 'folderId',
    value: folderId
  })
}

const setIsBlockedAccount = ({ commit }: any, isBlockedAccount: any) => {
  localStorage.setItem('isBlockedAccount', isBlockedAccount)
  commit(GENERIC_MUTATION, {
    property: 'isBlockedAccount',
    value: isBlockedAccount
  })
}

const setFolderName = ({ commit }: any, folderName: string) => {
  localStorage.setItem('folderName', folderName)
  commit(GENERIC_MUTATION, {
    property: 'folderName',
    value: folderName
  })
}

const setPagePagination = ({ commit }: any, pagePaginaton: string) => {
  localStorage.setItem('pagePagination', pagePaginaton)
  commit(GENERIC_MUTATION, {
    property: 'pagePagination',
    value: pagePaginaton
  })
}

const setStatusList = ({ commit }: any, statusList: any) => {
  localStorage.setItem('statusList', statusList)
  commit(GENERIC_MUTATION, {
    property: 'statusList',
    value: statusList
  })
}

const setCurrentStatus = ({ commit }: any, currentStatus: any) => {
  commit(GENERIC_MUTATION, {
    property: 'currentStatus',
    value: currentStatus
  })
}

const setTermSearch = ({ commit }: any, termSearch: any) => {
  commit(GENERIC_MUTATION, {
    property: 'termSearch',
    value: termSearch
  })
}

const setShowSpinContent = ({ commit }: any, value: boolean) => {
  commit(GENERIC_MUTATION, {
    property: 'showSpinContent',
    value
  })
}

const setOpenNewDocument = ({ commit }: any, value: boolean) => {
  commit(GENERIC_MUTATION, {
    property: 'openNewDocument',
    value
  })
}

const setOpenHistoric = ({ commit }: any, value: boolean) => {
  commit(GENERIC_MUTATION, {
    property: 'openHistoric',
    value
  })
}

const setTreeSelected = ({ commit }: any, value: any) => {
  commit(GENERIC_MUTATION, {
    property: 'treeSelected',
    value
  })
}

const setVaultSelected = ({ commit }: any, value: any) => {
  commit(GENERIC_MUTATION, {
    property: 'vaultSelected',
    value
  })
}

const setHomePage = ({ commit }: any, value: any) => {
  commit(GENERIC_MUTATION, {
    property: 'isHome',
    value
  })
}

const setDrawerMenu = ({ commit }: any, value: any) => {
  commit(GENERIC_MUTATION, {
    property: 'drawerMenu',
    value
  })
}

const setFilteredStatus = ({ commit }: any, value: any) => {
  commit(GENERIC_MUTATION, {
    property: 'filteredStatus',
    value
  })
}

export default <ActionTree<any, any>>{
  setShowSpinContent,
  setOpenNewDocument,
  setOpenSidebar,
  setEnvelops,
  fetchStatusEnvelopes,
  filteredStatusEnvelopes,
  setFolderId,
  setIsBlockedAccount,
  fetchEnvelops,
  fetchEnvelopesByVault,
  fetchHistoricEnvelops,
  fetchEnvelopesByUser,
  setDrawerMenu,
  setOpenHistoric,
  setFolderName,
  setPagePagination,
  setStatusList,
  setCurrentStatus,
  setTermSearch,
  fetchSearchEnvelope,
  setTreeSelected,
  setHomePage,
  setEnvelopsINeedToSign,
  setEnvelopsOthersPendingSign,
  fetchEnvelopesOthersPendingSign,
  fetchEnvelopesINeedToSign,
  setVaultSelected,
  setFilteredStatus
}
